"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Divider = _interopRequireDefault(require("./Divider.js"));
var _Flex = _interopRequireDefault(require("./Flex.js"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Row list component
 *
 * Intended as a list of `Row` components.
 */class RowList extends _react.default.PureComponent {
  /**
   * Render.
   * 
   * @return {ReactNode}
   */
  render() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Flex.default, {
      gap: this.props.gap,
      hidden: this.props.hidden,
      rootRef: this.props.rootRef,
      children: this.props.children.map((child, key) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
        children: [child, key !== (this.props.children?.length || 0) - 1 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider.default, {})]
      }, key))
    });
  }
}
var _default = exports.default = RowList;